import { memo, useCallback, useMemo } from 'react'

import { AppId } from '@inno-tools/container-bridge'
import { FullPageAppTemplate } from 'modules/app-registry/templates'
import { useNavigate } from 'react-router-dom'
import { useHistory, useNavigationContext, useUserContext } from 'shared/hooks'

import { useAvailableApps } from '../hooks/useAvailableApps'

const GdprApp = memo(
  () => {
    const navigate = useNavigate()
    const { location } = window
    const history = useHistory()
    const { user } = useUserContext()
    const { apps } = useAvailableApps()
    const { gdprState, setGdprState } = useNavigationContext()

    const handleNavigate = useCallback(
      ({ pathname: nextPathname }: { pathname: string }) => {
        const { pathname } = location

        if (pathname !== nextPathname) {
          navigate(nextPathname)
        }
      },
      [location, navigate]
    )

    const appProps = useMemo(
      () => ({
        user,
        history,
        initialPath: location.pathname,
        appPath: apps[AppId.GDPR].path,
        onNavigate: handleNavigate,
        gdprState,
        setGdprState,
        isWidget: false
      }),
      [user, history, location, apps, handleNavigate, gdprState, setGdprState]
    )

    return (
      <FullPageAppTemplate
        appId={AppId.GDPR}
        scope='gdpr'
        envKey={apps[AppId.GDPR].runtimeEnvKey}
        entryPath='./GdprApp'
        url={process.env.REACT_APP_GDPR_APP_DEV_PATH}
        appName={apps[AppId.GDPR].name}
        appProps={appProps}
      />
    )
  },
  // when there are no props, this is OK to use. without this comparison function, we will have higher memory usage
  () => true
)

export { GdprApp }
